(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabCompendiumRestriction', LabCompendiumRestriction);

    LabCompendiumRestriction.$inject = ['$resource'];

    function LabCompendiumRestriction ($resource) {
        var resourceUrl =  'api/lab-compendium-restrictions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/lab-compendium-restrictions/filter', method: 'GET', isArray: true}
        });
    }
})();
